
import FooterHeading from "./FooterHeading";

const FooterGrid = ({heading,links}) => {
    return (
        <div className="col-12 col-sm-6 col-lg-3 mb-4 mb-lg-0">
            <FooterHeading heading={heading}/>
            <ul>
                {links && links.map((item) =>
                    <li key={item.id}>
                        <a href={item.link} target={item.target}>{item.title}</a>
                    </li>
                )}                
            </ul>
        </div>
    );
};

export default FooterGrid;